import classNames from 'classnames';
import React from 'react';

interface Props {
    color?: 'soft' | 'grey800';
    size?: 'small';
    spacing?: 'half-margin' | 'double-margin' | 'no-margin';
}

const Paragraph: React.FunctionComponent<Props> = ({ children, color, size, spacing }) => {
    const classes = classNames('paragraph', {
        [`paragraph--${color}`]: color ? true : false,
        [`paragraph--${size}`]: size ? true : false,
        [`paragraph--${spacing}`]: spacing ? true : false,
    });

    return <p className={classes}>{children}</p>;
};

export default Paragraph;
